import React from 'react'
import { useLocation } from 'react-router-dom'

function PaymentIcon({ size = 28 }) {
    const location = useLocation()
    const isActive = location.pathname.startsWith('/payments')
    const color = isActive ? '#FFFFFF' : '#8F9DAC'

    return (
        <svg
            width={size}
            height={size}
            viewBox="0 0 28 28"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M14 22.7502C12.4454 23.4763 10.4032 23.9168 8.16665 23.9168C6.92307 23.9168 5.73962 23.7807 4.66665 23.5349C2.82131 23.1122 2.33331 22.0264 2.33331 20.2838V7.71646C2.33331 6.56749 3.54668 5.77835 4.66665 6.03486C5.73962 6.28062 6.92307 6.41683 8.16665 6.41683C10.4032 6.41683 12.4454 5.97625 14 5.25016C15.5546 4.52408 17.5967 4.0835 19.8333 4.0835C21.0769 4.0835 22.2603 4.2197 23.3333 4.46546C25.1786 4.88812 25.6666 5.97392 25.6666 7.71646V20.2838C25.6666 21.4329 24.4533 22.222 23.3333 21.9655C22.2603 21.7196 21.0769 21.5835 19.8333 21.5835C17.5967 21.5835 15.5546 22.024 14 22.7502Z"
                stroke={color}
                strokeWidth="1.8"
            />
            <path
                d="M16.9166 14.0002C16.9166 15.611 15.6108 16.9168 14 16.9168C12.3892 16.9168 11.0833 15.611 11.0833 14.0002C11.0833 12.3893 12.3892 11.0835 14 11.0835C15.6108 11.0835 16.9166 12.3893 16.9166 14.0002Z"
                stroke={color}
                strokeWidth="1.8"
            />
            <path
                d="M6.41669 15.1665V15.177"
                stroke={color}
                strokeWidth="1.8"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M21.5833 12.8242V12.8347"
                stroke={color}
                strokeWidth="1.8"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    )
}

export default PaymentIcon
